module.exports = __webpack_public_path__ + "img/sv96.e2b06e53.svg";